module.exports = __webpack_public_path__ + "static/media/less-than.b2a8f58a.svg";